import "./instrument"; // Import sentry asap
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Toaster } from "@/components/ui/toaster";
import "./index.css";
import App from "./App.tsx";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./providers/AuthProvider.tsx";
import { HideSidebarProvider } from "./providers/HideSidebarProvider.tsx";
import * as sentry from "@sentry/react";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme.tsx";
import BidThemeProvider from "./providers/BidThemeProvider.tsx";
import PushNotificationsProvider from "./providers/PushNotificationsProvider.tsx";
import ErrorBoundary from "./components/ErrorBoundary.tsx";

window.addEventListener("vite:preloadError", (_) => {
  window.location.reload();
});

const queryClient = new QueryClient();
const router = sentry.wrapCreateBrowserRouterV6(createBrowserRouter)([
  {
    path: "*",
    element: (
      <sentry.ErrorBoundary
        showDialog={true}
        dialogOptions={{
          lang: "pt-br",
          title: "Houve um problema ao carregar esta página",
          subtitle: "Recarregue a página ou tente novamente mais tarde.",
        }}
        fallback={<ErrorBoundary />}
      >
        <AuthProvider>
          <PushNotificationsProvider>
            <HideSidebarProvider>
              <Toaster />
              <App />
            </HideSidebarProvider>
          </PushNotificationsProvider>
        </AuthProvider>
      </sentry.ErrorBoundary>
    ),
  },
]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BidThemeProvider theme={theme}>
        <CssBaseline />
        <RouterProvider router={router}></RouterProvider>
      </BidThemeProvider>
    </QueryClientProvider>
  </StrictMode>
);
